import React from 'react';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-content">
        <p>&copy; {year} Viraj Pargaonkar. All rights reserved.</p>
        <div className="footer-links">
          <a
            href="https://www.linkedin.com/in/virajpargaonkar"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a href="mailto:virajnp@gmail.com" target="_blank" rel="noopener noreferrer">
            <i className="fas fa-envelope"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;